
import { errorToast } from "@/shared/services/helper";
export default function handlerErrorFromApis(error) {
    if(!error?.response) {
        return Promise.reject([`Error CORS: Check your NETWORK agian and refresh the page.`]);
    };
    const status = error?.response?.status;
    switch (status) {
        case 422:
            if (error.response.data.details) {
                return Promise.reject(`Error ${status}: ${error?.response?.data?.details?.[Object.keys(error?.response?.data?.details)?.[0]]}`);
            } else {
                return Promise.reject([`Error ${status}: ${error?.response?.data?.errors ?? error?.response?.data?.message ?? error?.response?.data?.error }`]);
            }
        case 401:
            errorToast('You Have Been Logged Out From This Device.');
            clearDataOnUnauthorised();
            break;
        case 400:
        case 500:
            return Promise.reject([`Error ${status}: ${ error?.response?.data?.message || error?.response?.data?.error || error?.response?.data?.errors}`]);
        default:
            return Promise.reject([`Error ${status}: Refresh the page and try again.`]);
    }
}

function clearDataOnUnauthorised() {
    try {
        window.cookies.keys().forEach(cookie => window.cookies.remove(cookie))
        window.store.dispatch('resetAllState');
        setTimeout(()=> {
            window.location.href = '/';
        }, 800)
        
    } catch (error) {
        console.log(error);
        errorToast(error)
    }
}